/**-----------------------------------------------------------------------------
 * Load in production only
 */
if (Mobi2Go.app.base_url === 'https://www.mobi2go.com') {
    Mobi2Go.onReady(load);
}

function load() {
    /**-------------------------------------------------------------------------
     * Script Setup
     * https://businesshelp.snapchat.com/en-US/article/pixel-website-install
     */
    const { headoffice } = Mobi2Go;
    const { Customer } = Mobi2Go;
    const { Analytics } = Mobi2Go;
    const E = Analytics.EVENTS;

    const snapchat_id = headoffice.analytics_snap_pixel_id;

    if (!snapchat_id) {
        return;
    }

    (function(win, doc, sdk_url) {
        if (win.snaptr) return;
        var tr = (win.snaptr = function() {
            tr.handleRequest
                ? tr.handleRequest.apply(tr, arguments)
                : tr.queue.push(arguments);
        });
        tr.queue = [];
        const s = 'script';
        const new_script_section = doc.createElement(s);
        new_script_section.async = !0;
        new_script_section.src = sdk_url;
        const insert_pos = doc.getElementsByTagName(s)[0];
        insert_pos.parentNode.insertBefore(new_script_section, insert_pos);
    })(window, document, 'https://sc-static.net/scevent.min.js');

    /**-------------------------------------------------------------------------
     * Abstraction
     */

    function initialise() {
        const email = Customer.getEmail();
        const phoneNumber = Customer.getPhoneNumber();
        let details;

        if (email || phoneNumber) {
            details = email
                ? { user_email: email }
                : { user_phone_number: phoneNumber };
        }

        snaptr('init', snapchat_id, details);

        const type = 'track';
        const event = 'PAGE_VIEW';

        snaptr(type, event);
    }

    function addedProduct(product) {
        const currency = headoffice.currency_abrv;
        const category = product.menu_product.category.name;
        const item_id = product.menu_product.plu;

        const type = 'track';
        const event = 'ADD_CART';
        const details = {
            currency,
            price: product.price.toFloat(),
            item_category: category,
            item_ids: [item_id],
        };

        snaptr(type, event, details);
    }

    function confirmedOrder(order) {
        order.getProducts().forEach(function(product) {
            const currency = headoffice.currency_abrv;
            const category = product.menu_product.category.name;
            const item_id = product.menu_product.plu;

            const type = 'track';
            const event = 'PURCHASE';
            const details = {
                currency,
                price: product.price.toFloat(),
                item_category: category,
                item_ids: [item_id],
            };

            snaptr(type, event, details);
        });
    }

    /**-------------------------------------------------------------------------
     * Application Glue
     */

    Analytics.bind({
        READY: initialise,
        ADDED_PRODUCT(product) {
            addedProduct(product);
        },
        CONFIRMED_ORDER(order) {
            confirmedOrder(order);
        },
    });
}
